export default __webpack_public_path__ + "static/media/297.4e769b49.jpg";